import { parametersChanged, connectedParametersChanged, expandParameterPanel, collapseParameterPanel } from "../../actions/filters";

import { connect } from "react-redux";

import ParameterPanel from "../../components/parameter_panel";

export default (purposeCountryParamMultiFilterMode = false) => {
  // Memoize the per-purpose parameter filter so it returns a STABLE array reference across
  // store updates when the parameter list + active purpose are unchanged. mapStateToProps runs
  // on EVERY store change (including a checkbox tick), and a fresh `.filter(...)` array each time
  // would change the identity of the TanStack table's `data` prop → rebuild every row model →
  // re-render all ~1,000 parameter rows on every tick (a staging-QA regression; the parameter
  // panel's LeafRow React.memo can only skip unchanged rows if their `row` object is referentially
  // stable). The underlying param list + active purpose only change when the list loads or the
  // purpose changes — never on a tick — so a one-entry memo is sufficient.
  let lastList, lastPurpose, lastFiltered;
  const parametersForPurpose = (activePurposeId, parameterList) => {
    if (parameterList === lastList && activePurposeId === lastPurpose) { return lastFiltered; }
    lastList = parameterList;
    lastPurpose = activePurposeId;
    lastFiltered = parameterList.filter(e => e.purposeIds.includes(activePurposeId));
    return lastFiltered;
  };

  const mapStateToProps = (state) => {
    let filterTitle, options;
    const hidden = !state.filters.showParametersPanel;
    const selectedValues = state.filters.parameters.selectedValues;
    let activePurposeId;

    if (!purposeCountryParamMultiFilterMode) {
      filterTitle = "Parameters";
      options = state.filters.parameters.options;
    } else {
      filterTitle = "+ Add Parameters";

      activePurposeId = state.filters.purpose.selectedValue.value;

      options = parametersForPurpose(activePurposeId, state.filters.parameters.options);
    }

    return { options, selectedValues, hidden, filterTitle, activePurposeId };
  };

  const changeCallback = purposeCountryParamMultiFilterMode ? connectedParametersChanged : parametersChanged;

  const mapDispatchToProps = dispatch => ({
    onOptionSelect: clickedOption => () => { dispatch(changeCallback(clickedOption)); },
    expandParameterPanel: () => { dispatch(expandParameterPanel()); },
    collapseParameterPanel: () => { dispatch(collapseParameterPanel()); }
  });

  return connect(mapStateToProps, mapDispatchToProps)(ParameterPanel);
};
